import { styled } from "@mui/system";

const GridContainer = styled("div")(({ theme, gridCount }: { theme: any, gridCount: number }) => ({
  display: "grid",
  gridTemplateColumns: `repeat(${gridCount}, 1fr)`,
  gap: "24px",

  padding: "24px 0px",
  "@media (min-width: 768.5px)": {
    padding: "24px 16px",
  },
  width: "100%",
  boxSizing: "border-box",
  [theme.breakpoints.down("lg")]: {
    gridTemplateColumns: "repeat(2, 1fr)",
  },
  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "repeat(1, 1fr)",
  },
}));

export default GridContainer;
